module.exports = __webpack_public_path__ + "img/hc_flag.8cfdcf3b.gif";